export {default as FrequencyTable} from './table'
